export default __webpack_public_path__ + "static/media/278.70a53fcd.gif";